import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "d-flex align-items-center py-1" }
const _hoisted_8 = { class: "me-4" }
const _hoisted_9 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-stock-table-toolbar": "base"
}
const _hoisted_13 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_add_stock"
}
const _hoisted_14 = { class: "svg-icon svg-icon-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Add Stock ")
const _hoisted_16 = { class: "card-body pt-0" }
const _hoisted_17 = { class: "btn-group dropstart" }
const _hoisted_18 = {
  key: 0,
  class: "btn btn-sm btn-light dropdown-toggle",
  type: "button",
  id: "actions",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_19 = {
  key: 1,
  class: "dropdown-menu",
  "aria-labelledby": "actions"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_StockFilter = _resolveComponent("StockFilter")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AddStockModal = _resolveComponent("AddStockModal")!
  const _component_EditStockModal = _resolveComponent("EditStockModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: "Search Stocks"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen031.svg" })
                ]),
                _hoisted_11
              ]),
              _createVNode(_component_StockFilter, { onFilterByType: _ctx.fetchData }, null, 8, ["onFilterByType"])
            ])
          ]),
          (_ctx.checkedStocks.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("button", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
                  ]),
                  _hoisted_15
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Datatable, {
              key: 0,
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": true
            }, {
              "cell-title": _withCtx(({ row: stock }) => [
                _createTextVNode(_toDisplayString(stock.title), 1)
              ]),
              "cell-address": _withCtx(({ row: stock }) => [
                _createTextVNode(_toDisplayString(stock.address), 1)
              ]),
              "cell-type": _withCtx(({ row: stock }) => [
                _createTextVNode(_toDisplayString(stock.type), 1)
              ]),
              "cell-actions": _withCtx(({ row: stock }) => [
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_18, " Actions "))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.transactions(stock.ID))
                          }, "Transactions", 8, _hoisted_20)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_edit_stock",
                            onClick: ($event: any) => (_ctx.selectStock(stock))
                          }, "Edit", 8, _hoisted_21)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.deleteStock(stock.ID))
                          }, "Delete", 8, _hoisted_22)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_AddStockModal, { reloadData: _ctx.fetchData }, null, 8, ["reloadData"]),
    _createVNode(_component_EditStockModal, {
      stock: _ctx.selectedStock,
      reloadData: _ctx.fetchData
    }, null, 8, ["stock", "reloadData"])
  ], 64))
}